export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/60"></div>

      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(0.56 0.22 15) 0px, transparent 50%), radial-gradient(circle at 80% 20%, oklch(0.68 0.18 85) 0px, transparent 40%), radial-gradient(circle at 60% 80%, oklch(0.55 0.10 180) 0px, transparent 40%)',
        }}
      ></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 高清不缓冲</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-3">
              玫瑰视频
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground-700 font-body font-light mt-1">
                热门影视一站聚合，高清流畅不缓冲
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[620px] lg:max-w-none mb-8">
              玫瑰视频📢精心汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等多平台热门影视资源，
              涵盖高清电视剧全集、电影大全与最新影视内容。无论你偏爱都市情感、烧脑悬疑还是古装巨制，
              这里都能找到心仪之选。全站资源高清流畅不缓冲，每日持续更新，让你的追剧体验从未如此畅快。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-vidicon-line text-accent-600 text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-950">10万+</div>
                  <div className="text-xs text-foreground-500">影视资源覆盖</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-timer-flash-line text-secondary-600 text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-950">每日更新</div>
                  <div className="text-xs text-foreground-500">准时上新不断档</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-primary-600 text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-950">安全流畅</div>
                  <div className="text-xs text-foreground-500">高清不缓冲</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即探索影视库
              </a>
              <a
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-background-300 text-foreground-700 font-medium text-sm whitespace-nowrap hover:bg-background-100 hover:text-foreground-950 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-hashtag"></i>
                查看热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20warm-toned%20abstract%20composition%20with%20overlapping%20film%20strips%20and%20soft%20bokeh%20lights%20in%20rose%20gold%20and%20amber%20hues%2C%20artistic%20video%20streaming%20concept%2C%20modern%20minimalist%20aesthetic%20with%20subtle%20geometric%20film%20reel%20patterns%2C%20elegant%20entertainment%20platform%20atmosphere%2C%20clean%20and%20sophisticated%20visual%20design%20with%20warm%20gradient%20background&width=1040&height=780&seq=hero-visual-rose-2026&orientation=landscape"
                alt="玫瑰视频 - 热门影视聚合平台主视觉"
                className="w-full h-full object-cover"
                title="玫瑰视频 - 热门影视聚合平台主视觉"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}